import React from "react";
import { useEffect } from "react";
import { Banner } from "flowbite-react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContextHelper";
import { useWidget } from "../context/WidgetContextHelper";

const WelcomeBanner = () => {
  const { user } = useAuth();
  const { welcomeWidget, getWelcomeWidget } = useWidget();

  useEffect(() => {
    (async () => {
      await getWelcomeWidget();
    })();
  }, []);

  const emailRegex = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/;
  const parts = welcomeWidget && welcomeWidget.content.split(emailRegex);
  const emails =
    (welcomeWidget && welcomeWidget.content.match(emailRegex)) || [];

  return (
    <Banner className="w-full">
      <div className="flex flex-col top-20 justify-between border border-gray-200 rounded-md p-4 mb-4 md:flex-row h-72 bg-white shadow-md">
        <div className="mb-4 md:mb-0 md:mr-4 flex flex-col justify-center order-2 md:order-1">
          <h2 className="mb-1 text-gray-900 text-4xl font-bold tracking-tight">
            Welcome {user.first_name} {user.last_name}
          </h2>
          <p className="text-md font-normal text-gray-500">
            {parts &&
              parts.map((part, index) => (
                <React.Fragment key={index}>
                  {part}
                  {index < emails.length && (
                    <Link
                      to={`mailto:${emails[index]}`}
                      className="font-medium text-primary-600 hover:underline pl-1"
                    >
                      {emails[index]}
                    </Link>
                  )}
                </React.Fragment>
              ))}
          </p>
        </div>
        <div className="flex h-2/4 md:h-full md:flex-row order-1 md:order-2 items-center">
          <img
            src={process.env.PUBLIC_URL + "/Welcome Banner.png"}
            alt="Banner Image"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </Banner>
  );
};

export default WelcomeBanner;
